import { HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class RecentBroadActivitiesRequest extends Request<never, void> {
  constructor(options?: RequestOptions<never>) {
    super({
      ...options,
      path: `/broad${options?.version ?? '/v2'}/me/investment_plans/activities`,
      method: 'POST'
    });
  }

  public execute(): Observable<void> {
    return super.execute().pipe(map((response: HttpResponse<any>) => response.body));
  }
}

export function getRecentBroadActivities(
  options?: RequestOptions<never>
): RecentBroadActivitiesRequest {
  return new RecentBroadActivitiesRequest(options);
}
